import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate, useLocation } from 'react-router-dom'
import * as FaIcons from 'react-icons/fa'
import '../assets/css/Sidebar.css'
import data from '../data/data.json'

function Sidebar() {
  const navigate = useNavigate()
  const location = useLocation()


  const handleItemClick = (path) => {
    navigate(path)
  }

  const menuItemsToShow = data.menuItems;

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        {menuItemsToShow.map((item, index) => {
          const IconComponent = FaIcons[item.icon];
          return (
            <motion.li
              key={item.id}
              className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleItemClick(item.path)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <span className="icon">{IconComponent ? <IconComponent /> : null}</span>
              <span className="text">{item.name}</span>
            </motion.li>
          );
        })}
      </ul>
    </div>
  )
}

export default Sidebar

